import { Component } from '@angular/core';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrl: './contact.component.scss'
})
export class ContactComponent {
    formData = {
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    };

    onSubmit() {
        // Will be connected to backend later
        console.log('Contact form submitted:', this.formData);
        alert('Thank you for contacting us! We will get back to you soon.');
        this.formData = { name: '', email: '', phone: '', subject: '', message: '' };
    }
}
